// src/components/AnnouncementBar/index.js
// Slim strip above the fold. Reuses the store's own banner sub-heading
// (real, already-fetched data) rather than a made-up marketing claim; falls
// back to generic, non-business-specific copy only when that's empty.
import React, { useState } from 'react';
import { X } from 'lucide-react';
import './index.css';

const AnnouncementBar = ({ config }) => {
  const [dismissed, setDismissed] = useState(false);
  const message = config?.banner?.sub_heading || 'Freshly Made Sweets, Delivered Across the UK';

  if (dismissed) return null;

  return (
    <div className="t16-announcement-bar">
      <p className="t16-announcement-text">{message}</p>
      <button
        type="button"
        className="t16-announcement-close"
        onClick={() => setDismissed(true)}
        aria-label="Dismiss announcement"
      >
        <X size={14} />
      </button>
    </div>
  );
};

export default AnnouncementBar;
